export default __webpack_public_path__ + "static/media/playIcon.6f367290.svg";